import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getSheet } from "../sheets";
import { colors } from "../utils";
import Loader from "./Loader";
import Container from "./Container";

const linksSheet = process.env.REACT_APP_LINKS_SHEET;

let colorUsages = 0;
const Color = styled.div`
  a {
    background: ${() => {
      const color = colors[colorUsages % colors.length];
      colorUsages += 1;
      return `${color}55`;
    }};

    color: black;
    display: inline-block;
    padding: 0 0.33rem;
    transition-property: background;

    &:hover {
      background: transparent;
    }
  }
`;

const Other = () => {
  const [links, setLinks] = useState();

  useEffect(() => {
    const fetchData = async () => {
      await getSheet(linksSheet, "Spinoff!A1:B", response => {
        const mapped = response.result.values.map(([name, url]) => ({
          name,
          url
        }));

        setLinks(mapped);
      });
    };

    fetchData();
  }, []);

  return (
    <Container>
      <p>
        Tutti i gruppi legati a serie o simili sono <b>spoiler</b>! Assicurati
        di essere in pari prima di entrare
      </p>
      {!links ? (
        <Loader>Caricando</Loader>
      ) : (
        links.map(({ name, url }) => (
          <Color key={url}>
            <a href={url}>{name}</a>
          </Color>
        ))
      )}
    </Container>
  );
};

export default Other;
